module.exports = __webpack_public_path__ + "42816a86f39922847568256548a7e8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/static/business-management-tools-subscription/collect-a-payment.png
// module id = 5178
// module chunks = 25